import React from 'react';
import { formatMacroClose, formatMacroPct, macroChangeClass } from './macroFormat';

function sourceLabel(row) {
  if (row.error) return row.error;
  if (row.kind === 'db') {
    const date = row.trade_date ? ` · ${row.trade_date}` : '';
    return `来源：market_index_daily${date}`;
  }
  return '来源：东方财富实时';
}

export default function MacroIndexGrid({ rows, emptyText = '暂无数据', canManage = false, onRemove }) {
  if (!rows?.length) {
    return <p className="decision-muted">{emptyText}</p>;
  }

  return (
    <div className="macro-equity-grid">
      {rows.map((row) => (
        <div className="decision-card macro-equity-card" key={row.code}>
          <div className="macro-card-head">
            <h3>{row.name}</h3>
            {canManage && onRemove ? (
              <button
                type="button"
                className="macro-card-remove"
                title="从列表移除"
                onClick={() => onRemove(row)}
              >
                ×
              </button>
            ) : null}
          </div>
          <div className={`macro-equity-change ${macroChangeClass(row.change_pct)}`}>
            {formatMacroPct(row.change_pct)}
          </div>
          {formatMacroClose(row.close) ? (
            <div className="decision-muted">点位 {formatMacroClose(row.close)}</div>
          ) : null}
          {row.chinabond_name ? (
            <p className="decision-muted macro-alias-note">中债 {row.chinabond_name}</p>
          ) : null}
          <p className={`decision-muted macro-source-note${row.error ? ' macro-source-warn' : ''}`}>
            {sourceLabel(row)}
          </p>
        </div>
      ))}
    </div>
  );
}
